import Box from 'components/atoms/box'
import Column from 'components/atoms/column'
import ProductCard from 'components/organisms/product-card'
import React from 'react'
import { MarketProductType } from 'types/market-product-type'

export interface CoursesGridProps {
  marketProducts?: MarketProductType[]
  pending?: boolean
}

const CoursesGrid: React.FC<CoursesGridProps> = ({
  marketProducts = [],
  pending,
}) => {
  return (
    <Box className="grid flex-1 grid-cols-1 gap-md py-md md:grid-cols-2 2xl:grid-cols-3">
      {pending && <Column>carregando...</Column>}
      {!!marketProducts?.length &&
        marketProducts.map((marketProduct) => (
          <ProductCard key={marketProduct._id} marketProduct={marketProduct} />
        ))}
    </Box>
  )
}

export default CoursesGrid
